import { defineComponent } from 'vue';
import PrivacyPolicy from './PrivacyPolicy.vue';
export default defineComponent({
    name: 'TermAndCondition',
    components: {
        PrivacyPolicy,
    },
});
